import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Form, FormGroup, Label, Input, Button, Row, Col } from 'reactstrap';
import { translate } from 'react-translate';
import { actionGetLogsList } from 'store/actions/logsActions';
import TableLogs from './TableLogs';
import Paginator from '../../components/Common/Paginator';
import Switch from '../../components/Common/Switch';
import Loading from 'plugins/TS-lib-utils-public/components/Loading/LoadingGlobal';

const ListLogs = ({ t }) => {
  const dispatch = useDispatch();
  const { logs, pagination } = useSelector((state) => state.logsReducer.logs);
  const [loading, setLoading] = useState(false);
  const [loadingLocal, setLoadingLocal] = useState(false);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [totalPage, setTotalPage] = useState(0);
  const [filters, setFilters] = useState({
    type: '',
    user: '',
    severity: '',
    module: '',
    message: '',
    dateFrom: '',
    dateTo: ''
  });

  useEffect(() => {
    dispatch(actionGetLogsList(page, limit, filters));
  }, []);

  useEffect(() => {
    if (logs && pagination) {
      setLoading(false);
      setLoadingLocal(false);
      setPage(pagination._page);
      setLimit(pagination._limit);
      setTotalPage(pagination._total_pages);
    }
  }, [logs, pagination]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setPage(0);
    dispatch(actionGetLogsList(0, limit, filters));
  };

  const handleResetFilters = () => {
    setFilters({
      type: '',
      user: '',
      severity: '',
      module: '',
      message: '',
      dateFrom: '',
      dateTo: ''
    });
    setPage(0);
    dispatch(actionGetLogsList(0, limit, {}));
  };

  const intervalOnOff = (isChecked) => {
    if (ListLogs.interval) {
      clearInterval(ListLogs.interval);
    }
    if (isChecked) {
      ListLogs.interval = setInterval(() => {
        dispatch(actionGetLogsList(page, limit, filters));
      }, 2000);
    }
  };

  const changePage = (newPage) => {
    setPage(newPage);
    dispatch(actionGetLogsList(newPage, limit, filters));
  };

  return (
    <div className="content user-manual pl-0 pr-0">
      <Card>
        <CardBody>
          <Loading loading={loading} />
          <Form onSubmit={handleFilterSubmit} className="mb-4">
            <Row className="align-items-end">
              <Col md="1">
                <FormGroup>
                  <Label>{t('type')}</Label>
                  <Input
                    type="select"
                    name="type"
                    value={filters.type}
                    onChange={handleFilterChange}
                  >
                    <option value="">{t('all')}</option>
                    <option value="doc">{t('doc')}</option>
                    <option value="pat">{t('pat')}</option>
                    <option value="sis">{t('sis')}</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md="1">
                <FormGroup>
                  <Label>{t('severity')}</Label>
                  <Input
                    type="select"
                    name="severity"
                    value={filters.severity}
                    onChange={handleFilterChange}
                  >
                    <option value="">{t('all')}</option>
                    <option value="error">{t('error')}</option>
                    <option value="warning">{t('warning')}</option>
                    <option value="info">{t('info')}</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup>
                  <Label>{t('module')}</Label>
                  <Input
                    type="text"
                    name="module"
                    value={filters.module}
                    onChange={handleFilterChange}
                    placeholder={t('enter_module')}
                  />
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup>
                  <Label>{t('message')}</Label>
                  <Input
                    type="text"
                    name="message"
                    value={filters.message}
                    onChange={handleFilterChange}
                    placeholder={t('enter_message')}
                  />
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup>
                  <Label>{t('date_from')}</Label>
                  <Input
                    type="date"
                    name="dateFrom"
                    value={filters.dateFrom}
                    onChange={handleFilterChange}
                  />
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup>
                  <Label>{t('date_to')}</Label>
                  <Input
                    type="date"
                    name="dateTo"
                    value={filters.dateTo}
                    onChange={handleFilterChange}
                  />
                </FormGroup>
              </Col>
              <Col md="2" className="d-flex align-items-end">
                <Button color="primary" type="submit" className="me-2">
                  {t('filter')}
                </Button>
                <Button color="secondary" onClick={handleResetFilters}>
                  {t('reset')}
                </Button>
              </Col>
            </Row>
          </Form>
          <Switch label={t('title-real-time')} callback={intervalOnOff} />
          <TableLogs data={logs} loading={loadingLocal} />
          <div className="d-flex justify-content-center align-items-center mt-3">
            <Paginator
              totalPages={totalPage}
              currentPage={page}
              pageSize={limit}
              filter={filters}
              callback={changePage}
            />
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default translate('logsDetail')(ListLogs);